import {useState, useEffect, useRef} from 'react'
import PropTypes from 'prop-types'
import {withRouter} from 'react-router'
import {Map, List} from 'immutable'

import {Button} from '../../../blocks/Buttons'
import Modals from '../../../../../../shared_components/core/modals/Modals'
import NewLoader from '../../../../../../shared_components/NewLoader'
import Logger from '../../../../../../lib/NewLogger'
import {useNotificationContext} from '../../../../../../shared_components/notifications/NotificationContext'

import './download.scss'

export const Download = props => {
  const [showModal, setShowModal] = useState(false)
  const {alwaysNotify} = useNotificationContext()
  const prevDownloadRef = useRef(props.everplanBundleDownload)

  const shouldHideDownloadLink = () => props.categoriesWithItemResponses.isEmpty()

  useEffect(() => {
    const prevDownload = prevDownloadRef.current
    const currentDownload = props.everplanBundleDownload

    // Only close modal when download changes from not empty to empty (download completed)
    if (!prevDownload.isEmpty() && currentDownload.isEmpty())
      setShowModal(false)

    // Update the ref for next comparison
    prevDownloadRef.current = currentDownload
  }, [props.everplanBundleDownload])

  const processDownload = () => {
    if (props.everplanBundleDownload.isEmpty()) {
      setShowModal(true)

      Logger.log({
        name: 'clicked_download_pdf_everplan',
        payload: {
          actor: props.actor,
          context: props.context,
          everplan_id: props.params.everplanId
        }
      })

      props.createResource({
        type: 'everplan-bundle-downloads',
        attributes: {'everplan-id': props.params.everplanId}
      })
    } else {
      alwaysNotify.shortInfo('Only one Everplan can be downloaded at a time. Please try again.')
    }
  }

  const dismissModal = () => {
    setShowModal(false)
  }

  if (shouldHideDownloadLink()) {
    return null
  } else {
    return (
      <div className='download'>
        <a onClick={processDownload}>Download</a>
        <Modals.SuccessPopUpModal showModal={showModal} showCloser={false}>
          <NewLoader loading={true} />
          <h2>Preparing your download...</h2>
          <p>
            This may take a few minutes. Feel free to close this window and
            continue using the site.
          </p>
          <Button onClick={dismissModal}>Got it</Button>
        </Modals.SuccessPopUpModal>
      </div>
    )
  }
}

Download.defaultProps = {everplanBundleDownload: Map()}

Download.propTypes = {
  categoriesWithItemResponses: PropTypes.instanceOf(List),
  actor: PropTypes.string,
  context: PropTypes.string,
  createResource: PropTypes.func,
  everplanBundleDownload: PropTypes.instanceOf(Map),
  params: PropTypes.shape({
    everplanId: PropTypes.string
  }),
  userConfig: PropTypes.instanceOf(Map)
}

export default withRouter(Download)
